<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- CONTENT -->
    <div class="content" [ngClass]="this.view" style="overflow-y: scroll;">

        <!-- Device Type Tabs -->
        <div class="device-tabs">
            <button
                class="tab-btn tab-btn-active-workouts"
                [class.active]="showActiveWorkouts"
                (click)="showActiveWorkoutsTab()">
                <mat-icon>fitness_center</mat-icon>
                {{'Active Workouts'|translate}} ({{getActiveWorkoutsCount()}})
            </button>
            <button
                class="tab-btn"
                [class.active]="selectedDeviceType === null && !showActiveWorkouts"
                (click)="filterByDeviceType(null)">
                {{'All'|translate}} ({{getDeviceTypeCount(null)}})
            </button>
            <button
                *ngFor="let deviceType of deviceTypes"
                class="tab-btn"
                [class.active]="selectedDeviceType === deviceType.id"
                (click)="filterByDeviceType(deviceType.id)">
                {{deviceType.name|translate}} ({{getDeviceTypeCount(deviceType.id)}})
            </button>
        </div>

        <!-- Status Filters -->
        <div class="status-filters" *ngIf="allResources.length > 0 && !showActiveWorkouts">
            <div class="filter-section">
                <input
                    type="text"
                    class="serial-search"
                    placeholder="{{'Search by serial number...'|translate}}"
                    (input)="filterBySerialNumber($event)"
                    [value]="serialNumberFilter"
                />
            </div>
            <div class="filter-section">
                <button
                    class="filter-btn"
                    [class.active]="selectedStatus === null"
                    (click)="filterByStatus(null)">
                    {{'All'|translate}}
                </button>
                <button
                    class="filter-btn filter-btn-online"
                    [class.active]="selectedStatus === 'online'"
                    (click)="filterByStatus('online')">
                    <mat-icon>check</mat-icon> {{'Online'|translate}}
                </button>
                <button
                    class="filter-btn filter-btn-offline"
                    [class.active]="selectedStatus === 'offline'"
                    (click)="filterByStatus('offline')">
                    <mat-icon>report_problem</mat-icon> {{'Offline'|translate}}
                </button>
                <button
                    class="filter-btn filter-btn-training"
                    [class.active]="selectedStatus === 'training'"
                    (click)="filterByStatus('training')">
                    <mat-icon>fitness_center</mat-icon> {{'Training'|translate}}
                </button>
                <button
                    class="filter-btn filter-btn-free"
                    [class.active]="selectedStatus === 'free'"
                    (click)="filterByStatus('free')">
                    <mat-icon>check</mat-icon> {{'Free'|translate}}
                </button>
            </div>
        </div>

        <div class="no-results" *ngIf="resources.length === 0 && allResources.length > 0 && !showActiveWorkouts">
            <mat-icon>search_off</mat-icon>
            <p>{{'No devices found matching the selected filters'|translate}}</p>
        </div>

        <!-- Active Workouts View -->
        <div class="active-workouts-container" *ngIf="showActiveWorkouts">
            <!-- Header with modal button -->
            <div class="active-workouts-header" style="display: flex; justify-content: flex-end; padding: 16px;">
                <button mat-raised-button color="primary" (click)="openActiveTrainingsModal()">
                    <mat-icon>list</mat-icon>
                    {{'View All Active Trainings'|translate}}
                </button>
            </div>

            <!-- Active Devices -->
            <div class="active-section" *ngIf="getActiveDevices().length > 0">
                <h3 class="section-title">
                    <mat-icon>devices</mat-icon>
                    {{'Devices with Active Workout'|translate}}
                </h3>
                <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap">
                    <div class="card p-8" *ngFor="let row of getActiveDevices()" fxFlex="33">
                        <div class="card-preview" fxFlex="100">
                            <div class="fuse-card active-workout-card" fxFlex="100"
                                 [style.cursor]="row.user ? 'pointer' : 'default'"
                                 (click)="row.user && openUserWorkoutDetails(row)">
                                <div class="p-16 pt-0 line-height-1.75">
                                    <h4>{{row.name}} <span *ngIf="row.serialNumber">({{row.serialNumber}})</span></h4>
                                    <div style="text-align: center;">
                                        <img src="{{row.image}}" style="max-width: 200px; max-height: 170px;"/>
                                    </div>

                                    <!-- Workout Parameters -->
                                    <div class="workout-params" *ngIf="row.workout">
                                        <div class="param-grid">
                                            <div class="param-item" *ngIf="row.currentCardNumber">
                                                <mat-icon>credit_card</mat-icon>
                                                <span class="param-label">{{'Card'|translate}}:</span>
                                                <span class="param-value">{{row.currentCardNumber}}</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentSpeed !== undefined && row.currentSpeed !== null">
                                                <mat-icon>directions_run</mat-icon>
                                                <span class="param-label">{{'Speed'|translate}}:</span>
                                                <span class="param-value">{{row.currentSpeed}} km/h</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentSpeedLevel !== undefined && row.currentSpeedLevel !== null">
                                                <mat-icon>trending_up</mat-icon>
                                                <span class="param-label">{{'Speed Level'|translate}}:</span>
                                                <span class="param-value">{{row.currentSpeedLevel}}</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentPulse !== undefined && row.currentPulse !== null">
                                                <mat-icon>favorite</mat-icon>
                                                <span class="param-label">{{'Pulse'|translate}}:</span>
                                                <span class="param-value">{{row.currentPulse}} bpm</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentCalories !== undefined && row.currentCalories !== null">
                                                <mat-icon>whatshot</mat-icon>
                                                <span class="param-label">{{'Calories'|translate}}:</span>
                                                <span class="param-value">{{row.currentCalories}} kcal</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentDistance !== undefined && row.currentDistance !== null">
                                                <mat-icon>straighten</mat-icon>
                                                <span class="param-label">{{'Distance'|translate}}:</span>
                                                <span class="param-value">{{row.currentDistance}} m</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentSteps !== undefined && row.currentSteps !== null">
                                                <mat-icon>directions_walk</mat-icon>
                                                <span class="param-label">{{'Steps'|translate}}:</span>
                                                <span class="param-value">{{row.currentSteps}}</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentInfraLevel !== undefined && row.currentInfraLevel !== null">
                                                <mat-icon>wb_incandescent</mat-icon>
                                                <span class="param-label">{{'Infra Level'|translate}}:</span>
                                                <span class="param-value">{{row.currentInfraLevel}}</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentVacuLevel !== undefined && row.currentVacuLevel !== null">
                                                <mat-icon>waves</mat-icon>
                                                <span class="param-label">{{'Vacu Level'|translate}}:</span>
                                                <span class="param-value">{{row.currentVacuLevel}}</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentCollagenFlag">
                                                <mat-icon>spa</mat-icon>
                                                <span class="param-label">{{'Collagen'|translate}}:</span>
                                                <span class="param-value">{{'Active'|translate}}</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.currentLymphFlag">
                                                <mat-icon>opacity</mat-icon>
                                                <span class="param-label">{{'Lymph'|translate}}:</span>
                                                <span class="param-value">{{'Active'|translate}}</span>
                                            </div>
                                            <div class="param-item" *ngIf="row.timeLeft !== undefined && row.timeLeft !== null && row.timeLeft > 0">
                                                <mat-icon>timer</mat-icon>
                                                <span class="param-label">{{'Time Left'|translate}}:</span>
                                                <span class="param-value">{{formatTimeLeft(row.timeLeft)}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Active Calendar Reservations -->
            <div class="active-section" *ngIf="activeReservations.length > 0">
                <h3 class="section-title">
                    <mat-icon>event</mat-icon>
                    {{'Active Calendar Sessions'|translate}}
                </h3>
                <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap">
                    <div class="card p-8" *ngFor="let reservation of activeReservations" fxFlex="33">
                        <div class="card-preview" fxFlex="100">
                            <div class="fuse-card reservation-card" fxFlex="100">
                                <div class="p-16 line-height-1.75">
                                    <h4 *ngIf="reservation.customer">
                                        <mat-icon class="inline-icon">person</mat-icon>
                                        {{reservation.customer?.firstName}} {{reservation.customer?.lastName}}
                                    </h4>

                                    <div class="reservation-info">
                                        <div class="info-row" *ngIf="reservation.service">
                                            <mat-icon>spa</mat-icon>
                                            <span>{{reservation.service.name}}</span>
                                        </div>

                                        <div class="info-row">
                                            <mat-icon>schedule</mat-icon>
                                            <span>{{reservation.startDate | date:'HH:mm'}} - {{reservation.endDate | date:'HH:mm'}}</span>
                                        </div>

                                        <div class="info-row" *ngIf="reservation.reservedResources && reservation.reservedResources.length > 0">
                                            <mat-icon>devices</mat-icon>
                                            <span>{{getResourceForReservation(reservation)?.name || reservation.reservedResources[0].name}}</span>
                                        </div>

                                        <div class="info-row" *ngIf="getEmployeeForReservation(reservation)">
                                            <mat-icon>supervised_user_circle</mat-icon>
                                            <span>{{'Employee'|translate}}: {{getEmployeeForReservation(reservation)?.firstName}} {{getEmployeeForReservation(reservation)?.lastName}}</span>
                                        </div>

                                        <div class="info-row" *ngIf="reservation.description">
                                            <mat-icon>notes</mat-icon>
                                            <span>{{reservation.description}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- No Active Workouts -->
            <div class="no-results" *ngIf="getActiveDevices().length === 0 && activeReservations.length === 0">
                <mat-icon>sentiment_satisfied</mat-icon>
                <p>{{'No active workouts at the moment'|translate}}</p>
            </div>
        </div>

        <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap" *ngIf="!showActiveWorkouts">
            <div class="card p-8" *ngFor="let row of resources" fxFlex="33">
                <!-- PREVIEW -->
                <div class="card-preview" fxFlex="100">

                    <div class="fuse-card" fxFlex="100"
                         [style.cursor]="row.user ? 'pointer' : 'default'"
                         (click)="row.user && openUserWorkoutDetails(row)">

                        <div class="p-16 pt-0 line-height-1.75">
                            <h4>{{row.name}} <span *ngIf="row.serialNumber">({{row.serialNumber}})</span></h4>
                            <div style="text-align: center;">
                                <img src="{{row.image}}" style="max-width: 200px; max-height: 170px;"/>
                            </div>

                            <!-- Workout Parameters -->
                            <div class="workout-params" *ngIf="row.workout">
                                <div class="param-grid">
                                    <div class="param-item" *ngIf="row.currentCardNumber">
                                        <mat-icon>credit_card</mat-icon>
                                        <span class="param-label">{{'Card'|translate}}:</span>
                                        <span class="param-value">{{row.currentCardNumber}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentSpeed !== undefined && row.currentSpeed !== null">
                                        <mat-icon>directions_run</mat-icon>
                                        <span class="param-label">{{'Speed'|translate}}:</span>
                                        <span class="param-value">{{row.currentSpeed}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentSpeedLevel !== undefined && row.currentSpeedLevel !== null">
                                        <mat-icon>trending_up</mat-icon>
                                        <span class="param-label">{{'Speed Level'|translate}}:</span>
                                        <span class="param-value">{{row.currentSpeedLevel}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentPulse !== undefined && row.currentPulse !== null">
                                        <mat-icon>favorite</mat-icon>
                                        <span class="param-label">{{'Pulse'|translate}}:</span>
                                        <span class="param-value">{{row.currentPulse}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentCalories !== undefined && row.currentCalories !== null">
                                        <mat-icon>whatshot</mat-icon>
                                        <span class="param-label">{{'Calories'|translate}}:</span>
                                        <span class="param-value">{{row.currentCalories}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentDistance !== undefined && row.currentDistance !== null">
                                        <mat-icon>straighten</mat-icon>
                                        <span class="param-label">{{'Distance'|translate}}:</span>
                                        <span class="param-value">{{row.currentDistance}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentSteps !== undefined && row.currentSteps !== null">
                                        <mat-icon>directions_walk</mat-icon>
                                        <span class="param-label">{{'Steps'|translate}}:</span>
                                        <span class="param-value">{{row.currentSteps}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentInfraLevel !== undefined && row.currentInfraLevel !== null">
                                        <mat-icon>wb_incandescent</mat-icon>
                                        <span class="param-label">{{'Infra Level'|translate}}:</span>
                                        <span class="param-value">{{row.currentInfraLevel}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentVacuLevel !== undefined && row.currentVacuLevel !== null">
                                        <mat-icon>waves</mat-icon>
                                        <span class="param-label">{{'Vacu Level'|translate}}:</span>
                                        <span class="param-value">{{row.currentVacuLevel}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentCollagenFlag">
                                        <mat-icon>spa</mat-icon>
                                        <span class="param-label">{{'Collagen'|translate}}:</span>
                                        <span class="param-value">{{'Active'|translate}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.currentLymphFlag">
                                        <mat-icon>opacity</mat-icon>
                                        <span class="param-label">{{'Lymph'|translate}}:</span>
                                        <span class="param-value">{{'Active'|translate}}</span>
                                    </div>
                                    <div class="param-item" *ngIf="row.timeLeft !== undefined && row.timeLeft !== null && row.timeLeft > 0">
                                        <mat-icon>timer</mat-icon>
                                        <span class="param-label">{{'Time Left'|translate}}:</span>
                                        <span class="param-value">{{formatTimeLeft(row.timeLeft)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-8 pt-0" fxLayout="column" fxLayoutGap="8px">
                            <!-- First Row: Status + Details -->
                            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
                                <a *ngIf="row.serviceDeviceId && row.online && !row.groupingDevice" mat-button mat-stroked-button color="primary"
                                   [routerLinkActive]="[]"><mat-icon>check</mat-icon> Online</a>

                                <a *ngIf="row.serviceDeviceId && !row.online && !row.groupingDevice" mat-button mat-stroked-button color="warning"
                                   [routerLinkActive]="[]"><mat-icon>report_problem</mat-icon> Offline</a>

                                <a *ngIf="row.serviceDeviceId && row.workout && !row.groupingDevice" mat-button mat-stroked-button color="accent"
                                   [routerLinkActive]="[]"><mat-icon>fitness_center</mat-icon> {{'Training'|translate}}</a>

                                <a *ngIf="row.serviceDeviceId && !row.workout && !row.groupingDevice" mat-button mat-stroked-button color="accent"
                                   [routerLinkActive]="[]"><mat-icon>check</mat-icon> {{'Free'|translate}}</a>

                                <a *ngIf="row.serviceDeviceId" mat-button mat-stroked-button color="accent"
                                   (click)="openResourceDetails(row); $event.stopPropagation()"
                                   [routerLinkActive]="[]">
                                    <mat-icon>info</mat-icon> {{'Details'|translate}}
                                </a>

                                <div *ngIf="!row.serviceDeviceId" style="color: red;">
                                    {{'Not connected'|translate}}
                                </div>
                            </div>

                            <!-- Second Row: Calendar + Statistics -->
                            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px" *ngIf="row.serviceDeviceId">
                                <a mat-button mat-stroked-button color="primary"
                                   (click)="openResourceCalendar(row); $event.stopPropagation()"
                                   [routerLinkActive]="[]">
                                    <mat-icon>event</mat-icon> {{'Calendar'|translate}}
                                </a>

                                <a mat-button mat-stroked-button color="accent"
                                   (click)="openDeviceStats(row); $event.stopPropagation()"
                                   [routerLinkActive]="[]">
                                    <mat-icon>bar_chart</mat-icon> {{'Statistics'|translate}}
                                </a>
                            </div>
                        </div>

                    </div>

                </div>
                <!-- / PREVIEW -->
            </div>


        </div>
    </div>

</div>
